import * as tslib_1 from "tslib";
import { workflowCenterApi, listApi as Application } from '@cloudpivot/api';
import { utils } from '@cloudpivot/common';
const state = {
    favoriteList: [],
    itemList: [],
    searchList: [],
    searchTotal: 0,
    wd: '',
    asideTitleI18n: {},
    asideTitle: '',
    applicationPageTitle: '',
    applicationPageTitleI18n: {},
    isShowSearchNoData: false,
    isShowSearchResult: false,
    unFinishedListCount: 0,
    unReadListCount: 0,
    userId: '',
    userData: {},
    dataItemList: [],
    code: ''
};
const mutations = {
    setCode(state, data) {
        state.code = data;
    },
    // 设置常用流程列表
    setFavoriteList(state, data) {
        state.favoriteList = data;
    },
    // 设置发起流程列表
    setItemList(state, data) {
        state.itemList = data;
        state.isShowSearchResult = false;
        if (state.itemList && state.itemList.length) {
            state.isShowSearchNoData = false;
        }
        else {
            state.isShowSearchNoData = true;
        }
    },
    // 设置发起流程根据流程名称搜索的流程列表
    setSearchList(state, data) {
        state.searchList = data.appList;
        state.searchTotal = data.size ? data.size : 0;
        state.isShowSearchResult = true;
        if (state.searchList && state.searchList.length) {
            state.searchList.forEach((item) => {
                item.appName = utils.searchHighLight(state.wd, item.appName);
                if (item.dataList && item.dataList.length) {
                    item.dataList.forEach((list) => {
                        list.name = utils.searchHighLight(state.wd, list.name);
                    });
                }
            });
        }
        if (state.searchList && state.searchList.length) {
            state.isShowSearchNoData = false;
        }
        else {
            state.isShowSearchNoData = true;
        }
    },
    // 设置侧边栏title
    setAsideTitle(state, app) {
        if (!app || !app.name)
            return;
        console.log('titile', app);
        state.asideTitle = app.name;
        state.asideTitleI18n = app.name_i18n;
    },
    // 设置应用中心页面title
    setApplicationPageTitle(state, app) {
        if (!app)
            return;
        state.applicationPageTitle = app.name;
        state.applicationPageTitleI18n = app.name_i18n;
    },
    // 设置待办待阅消息条数
    setListCoutnt(state, counts) {
        if (!counts)
            return;
        state.unFinishedListCount = counts.workItemCount;
        state.unReadListCount = counts.circulateItemCount;
    },
    // 设置用户id & 信息
    setUserId(state, data) {
        if (data.id) {
            state.userId = data.id;
            state.userData = data;
        }
    },
    // 设置数据项列表
    setDataItemList(state, data) {
        if (data) {
            state.dataItemList = data.filter((d) => d.published);
        }
    }
};
const actions = {
    // 请求常用流程列表数据
    getFavoriteWorkflowList({ commit, state }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield workflowCenterApi.getFavoriteWorkflowList();
            if (!res.errcode) {
                commit('setFavoriteList', res.data);
            }
        });
    },
    // 请求发起流程列表数据
    getWorkflowList({ commit, state }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield workflowCenterApi.getMyWorkflowList(false);
            if (!res.errcode) {
                commit('setItemList', res.data);
            }
            return res;
        });
    },
    // 根据流程名称查询可发起的流程
    searchMyWorkflowList({ commit, state }, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            state.wd = params.workflowName;
            const res = yield workflowCenterApi.searchMyWorkflowList(params);
            if (!res.errcode) {
                commit('setSearchList', res.data);
            }
        });
    },
    // 获取待办待阅列表条数
    getWorkCount({ commit }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // console.log('get count now', Date.now());
            const res = yield workflowCenterApi.getWorkCount();
            if (res.errcode === 0) {
                commit('setListCoutnt', res.data);
            }
        });
    },
    // 获取数据项列表
    getDataItemList({ commit }, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield Application.getDataItemList(params);
            if (res.errcode === 0) {
                commit('setDataItemList', res.data);
            }
        });
    },
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
